import { useContext, useEffect } from 'react';

import { PublicShowGlowContext } from '~/common/providers/public-circular-glow';
import { Typography } from '~/common/components/Typography';

interface IPublicPage {
  children?: any;
  title?: string;
  hasCircleCenterBlur?: boolean;
}

export const PublicPage: React.FC<IPublicPage> = ({
  children,
  title,
  hasCircleCenterBlur,
}) => {
  const { setShowGlow } = useContext(PublicShowGlowContext);
  useEffect(() => {
    if (hasCircleCenterBlur) {
      setShowGlow(hasCircleCenterBlur);
    } else {
      setShowGlow(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasCircleCenterBlur]);

  return (
    <>
      {!!title && <Typography.Title size="h4">{title}</Typography.Title>}
      {children}
    </>
  );
};
